export const StudentInformationTabLabels = {
    cpr: "ID",
    first_name: "First Name",
    additional_names: "Additional Names",
    gender: "Gender",
    phone_number: "Phone Number",
    email: "Email",
    birthdate: "Birthdate",
    school_name: "School Name",
    school_grade: "School Grade",
    address: "Address",
    primary_emergency_contact_name: "Primary Emergency Contact Name",
    primary_emergency_relationship: "Relationship",
    primary_emergency_phone: "Primary Emergency Number",
    emergency_contact_name: "Emergency Contact Name",
    emergency_relationship: "Relationship",
    emergency_phone: "Emergency Number",
    grade_updated: "Grade Updated",
    no_call: "No Call",
    delinquent: "Delinquent",
    expelled: "Expelled",
    registration_date: "Registration Date",
    notes: "Notes"
}